import { config } from '../config';

const API_BASE_URL = config.otpUrl || process.env.REACT_APP_OTP_URL || 'http://localhost:8081/api';

export const validateOTP = async (userIdentifier: string, otp: string, appIdentifier: string) => {
  const url = `${API_BASE_URL}/validate`;
  console.log(`[validateOTP] Calling: ${url} with userIdentifier=${userIdentifier} otp=${otp}`);

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ userIdentifier, otp, appIdentifier }),
  });

  console.log(`[validateOTP] Status: ${response.status}`);

  if (!response.ok) {
    const errorMsg = await response.text();
    console.error(`[validateOTP] Error: ${errorMsg}`);
    throw new Error(errorMsg || 'OTP validation failed');
  }

  const data = (await response.json()) as { token?: unknown };

  if (!data || typeof data.token !== 'string') {
    throw new Error('Invalid response: token missing');
  }

  return { token: data.token };

};

export const generateOTP = async (userName: string, recipientEmail: string, appIdentifier: string ) => {
  const url = `${API_BASE_URL}/generate`;
  console.log(`[generateOTP] Calling: ${url} with userEmail=${recipientEmail}`);

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ userName, recipientEmail, appIdentifier }),
  });

  console.log(`[generateOTP] Status: ${response.status}`);

  if (!response.ok) {
    const errorMsg = await response.text();
    console.error(`[generateOTP] Error: ${errorMsg}`);
    throw new Error(errorMsg);
  }

  const data = await response.text();
  console.log(`[generateOTP] Response:`, data);
  return data;

};